module.exports = __webpack_public_path__ + "resources/0d7c6bd038e48f928733363ce6c1955e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/basic.png
// module id = 204
// module chunks = 0